export default "__VITE_ASSET__C8SUZ6dJ__"